import _classCallCheck from "/Users/katnoria/dev/workspaces/web/katnoria.com/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/katnoria/dev/workspaces/web/katnoria.com/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/katnoria/dev/workspaces/web/katnoria.com/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/katnoria/dev/workspaces/web/katnoria.com/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/katnoria/dev/workspaces/web/katnoria.com/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { DataFlowNode } from './dataflow';
export var GraticuleNode = /*#__PURE__*/function (_DataFlowNode) {
  _inherits(GraticuleNode, _DataFlowNode);

  var _super = _createSuper(GraticuleNode);

  function GraticuleNode(parent, params) {
    var _this;

    _classCallCheck(this, GraticuleNode);

    _this = _super.call(this, parent);
    _this.params = params;
    return _this;
  }

  _createClass(GraticuleNode, [{
    key: "clone",
    value: function clone() {
      return new GraticuleNode(null, this.params);
    }
  }, {
    key: "assemble",
    value: function assemble() {
      return Object.assign({
        type: 'graticule'
      }, this.params === true ? {} : this.params);
    }
  }]);

  return GraticuleNode;
}(DataFlowNode);